export const messagesState = {
  messages: [],
  count: 0,
  unreadMessages: [],
  unreadCount: 0
}